import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";

export function useProjects() {
	/** Query */
	const {
		data: projects,
		isLoading,
		queryKey,
		refetch,
	} = useQuery({
		queryKey: ["projects"],
		queryFn: async () => {
			const response = await client.projects.index.$get({
				query: { limit: "5000", state: "active" },
			});
			const data = await responseHandler(response);
			return data.projects;
		},
	});

	/** Return */
	return { projects, isLoading, queryKey, refetch };
}
